
<Popover @open="handleOpen" @close="handleClose">
    <template #trigger>
        <span class="concession-popover-default-trigger">
            <slot name="trigger">{{ displayConcession }}</slot>
        </span>
    </template>
    <template #content="{ close }">
        <div class="concession-popover-content" v-if="setCloseFunction(close)">
            <slot
                :close="close"
                :concession="displayConcession"
                :carId="carId"
                :carUuid="carUuid"
            >
                <div class="concession-info">
                    <div class="concession-name-row">
                        <div class="concession-name">{{ displayConcession }}</div>
                    </div>
                    <div v-if="secondaryInfo" class="concession-id">
                        {{ secondaryInfo }}
                    </div>
                </div>
            </slot>

            <div class="concession-popover-actions">
                <Button
                    v-if="showTripsButton"
                    v-tooltip="getTripsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageTrips && isConcessionFiltered"
                    :class="{
                        'current-page': isCurrentPageTrips && isConcessionFiltered,
                    }"
                    @onClick="handleNavigate('trips', close)"
                >
                    <i class="ri-steering-2-line"></i>
                    <span class="button-hotkey">E</span>
                </Button>

                <Button
                    v-if="showShiftsButton"
                    v-tooltip="getShiftsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageShifts && isConcessionFiltered"
                    :class="{
                        'current-page': isCurrentPageShifts && isConcessionFiltered,
                    }"
                    @onClick="handleNavigate('shifts', close)"
                >
                    <i class="ri-repeat-line"></i>
                    <span class="button-hotkey">S</span>
                </Button>

                <Button
                    v-if="showCarsButton"
                    v-tooltip="getCarsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageCars && isConcessionFiltered"
                    :class="{
                        'current-page': isCurrentPageCars && isConcessionFiltered,
                    }"
                    @onClick="handleNavigate('cars', close)"
                >
                    <i class="ri-car-line"></i>
                    <span class="button-hotkey">F</span>
                </Button>
            </div>

            <div v-if="$slots.actions" class="concession-popover-custom-actions">
                <slot
                    name="actions"
                    :close="close"
                    :concession="displayConcession"
                    :carId="carId"
                    :carUuid="carUuid"
                />
            </div>
        </div>
    </template>
</Popover>
